module.exports = __webpack_public_path__ + "9c3867f644935585ca1c0a0a9d14dc98.svg";